import script from "./TabYoboWage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabYoboWage.vue?vue&type=script&setup=true&lang=ts"

import "./TabYoboWage.vue?vue&type=style&index=0&id=fe636298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe636298"]])

export default __exports__